import { SITE_ID } from 'Douleutaras/constants/localization';
import { useLocalization } from 'Douleutaras/hooks/localization';
import { useAppSelector } from 'Douleutaras/redux/hooks';
import { usersSelector } from 'Douleutaras/redux/data/users/usersSlice';
import logoYourHero from 'Assets/layout/job/icon-logo-yourhero-round.svg';
import logoDouleutaras from 'Assets/layout/job/icon-logo-douleutaras-round.svg';
import { JSONApiDataObject, SellerProfileCustom } from 'Douleutaras/types';

export const useSellerAttributes = (sellerId: string) => {
  const { siteId } = useLocalization();

  // get default site logo for avatar
  const defaultLogo = siteId === SITE_ID.IE ? logoYourHero : logoDouleutaras;

  const seller = useAppSelector(state => usersSelector.selectById(state, sellerId)) as JSONApiDataObject<SellerProfileCustom>;

  if (!seller) {
    return {
      mugshot: defaultLogo,
      defaultLogo,
      paymentMethodsSupported: false
    };
  }

  return {
    mugshot: seller.attributes.mugshot || defaultLogo,
    defaultLogo,
    // The condition is more than 2 because the user can have cash, cash + credit card or both + more which is 2+
    paymentMethodsSupported: seller.attributes.availablePaymentMethods.length > 2
  };
};
